import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const SubscriptionDetailPage = lazy(
  () => import('@/pages/subscriptions/detail'),
);

export const Route = createFileRoute('/subscriptions/$id')({
  component: function SubscriptionRoute() {
    const { id } = Route.useParams();
    return (
      <Suspense fallback={<TableSkeleton />}>
        <SubscriptionDetailPage subscriptionId={id} />
      </Suspense>
    );
  },
});
